<div class="grid justify-content-center">
  <div class="col">
    <div class="card">
      <div id="invoice-content">
        <div class="invoice">
          <div class="invoice-header">
            <div class="invoice-company">
              <img
                *ngIf="sale.entity?.images?.length"
                [alt]="sale.entity.tradingName"
                [src]="
                  sale.entity?.images | getFirstAvailableImageForSize: '200'
                "
                class="logo-image"
                id="invoice-logo"
              />
              <div class="company-name">
                {{ sale.entity?.tradingName || 'N/A' }}
              </div>
              <div>{{ sale.entity?.sector || 'N/A' }}</div>
              <div>{{ sale.entity?.supplyingLocation || 'N/A' }}</div>
              <div>{{ sale.entity?.contactPersonNumber || 'N/A' }}</div>
              <ng-container
                *ngIf="
                  (selectedOrganization &&
                    selectedOrganization?.tradingName ==
                      sale.entity?.tradingName) ||
                  'N/A'
                "
              >
                <div class="invoice-details">
                  <div class="supplier-address pr-5">
                    <div>
                      {{ selectedOrganization?.physicalAddressLineOne }}
                    </div>
                    <div>
                      {{ selectedOrganization?.physicalAddressLineTwo }}
                    </div>
                    <div>{{ selectedOrganization?.physicalAddressCity }}</div>
                    <div>{{ selectedOrganization?.country }}</div>
                  </div>

                  <div class="supplier-details">
                    <div class="invoice-details">
                      <div class="supplier-details">
                        <div class="invoice-label">CK</div>
                        <div class="invoice-label">Tax Number</div>
                        <div class="invoice-label">Tel</div>
                        <div class="invoice-label">Web</div>
                      </div>
                      <div class="supplier-details">
                        <div>
                          {{ selectedOrganization?.registrationNumber }}
                        </div>
                        <div>{{ selectedOrganization?.taxNumber }}</div>
                        <div>{{ selectedOrganization?.contactNumber }}</div>
                        <div>{{ selectedOrganization?.websiteAddress }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="invoice-detail-section">
              <div class="invoice-title">TAX INVOICE / RECEIPT</div>
              <div class="invoice-details">
                <div class="invoice-label">DATE</div>
                <div class="invoice-value">
                  {{ sale.orderDate | date: 'dd/MM/yyyy' }}
                </div>
                <!-- TODO Add invoice number -->
                <div class="invoice-label">RECEIPT #</div>
                <div class="invoice-value">{{ sale.reference }}</div>
              </div>
            </div>
          </div>
          <div
            *ngIf="sale.receivingEntity && sale.receivingLocation"
            class="invoice-to"
          >
            <div class="bill-to">BILL TO</div>
            <div class="invoice-to-info">
              <div>
                {{ sale.receivingEntity?.tradingName }}
              </div>
              <div>
                {{ sale.receivingLocation?.name }}
              </div>
              <div>
                {{ sale.receivingLocation?.contactPersonName }}
              </div>
              <div>
                {{ sale.receivingLocation?.contactPersonNumber }}
              </div>
            </div>
          </div>
          <div class="invoice-items">
            <table *ngFor="let charge of sale.charges">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Discounted Price</th>
                  <th>Tax</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of charge.items">
                  <td>{{ item.product.name }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.actualPrice | number: '1.2-2' }}</td>
                  <td>
                    {{
                      item.actualPrice !== item.price
                        ? (item.price | number: '1.2-2')
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      item.price
                        | getTaxValueOfPrice: item.taxRate
                        | number: '1.2-2'
                    }}
                  </td>
                  <td>{{ item.quantity * item.price | number: '1.2-2' }}</td>
                </tr>
              </tbody>
              <!-- <tfoot>
                <tr>
                  <td>
                    <strong>{{ charge.type }} Total</strong>{{ charge.total }}
                  </td>
                </tr>
              </tfoot> -->
            </table>
          </div>
          <div class="invoice-summary">
            <div class="invoice-notes">
              <ng-container *ngIf="sale.events[0].comment">
                <b>NOTES</b>
                <p>
                  {{ sale.events[0].comment }}
                </p>
              </ng-container>
              <div class="grid justify-content-center" style="display: none">
                <div class="col md:col-3">
                  <!--
                    Replace with a QR Code at some point
                    <img class="logo-image" [src]="'assets/layout/images/logo-dark.svg'" alt="Boma :: Trade Your Way"
                    style="max-width: 150px;" /> -->
                </div>
                <b>View this receipt online</b>
                <div>QR code with the url.</div>
              </div>
            </div>
            <div>
              <div class="invoice-details">
                <div class="invoice-label">SUBTOTAL</div>
                <div class="invoice-value">
                  {{ sale.currencySymbol
                  }}{{ sale.charges[0].totalWithoutVat | number: '1.2-2' }}
                </div>

                <div class="invoice-label">DISCOUNT</div>
                <div class="invoice-value">
                  -{{ sale.charges[0].currencySymbol }}
                  {{ sale.charges[0].totalDiscount }}
                </div>

                <div class="invoice-label">TAX</div>
                <div class="invoice-value">
                  {{ sale.currencySymbol
                  }}{{ sale.charges[0].totalVat | number: '1.2-2' }}
                </div>

                <div class="invoice-label">GRAND TOTAL</div>
                <div class="invoice-value">
                  {{ sale.currencySymbol
                  }}{{ sale.charges[0].total | number: '1.2-2' }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mx-0">
            <boma-print-footer
              [footerText]="'Sales Receipt'"
            ></boma-print-footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
